import React from 'react';
import cx from 'classnames';

import {
  DropDownList,
  DropDownListValueProps,
  DropdownWrapper,
  ExportedDropdownProps,
} from 'spindl-shared-components';

import { CELL_DROPDOWN_X_OFFSET, CELL_DROPDOWN_Y_OFFSET } from '../../../lib/constants';
import InternalCellSelectDropDown from './CellSelectDropDown';
import {
  CellSelectDropDownProps,
  CellSelectDropDownValueProps as InternalCellSelectDropDownValueProps,
} from './types';
import styles from './CellSelectDropDownOverride.module.scss';

export type { CellSelectDropDownProps }; // MANUAL OVERRIDE

// MANUAL OVERRIDE
export type CellSelectDropDownValueProps = ExportedDropdownProps<
InternalCellSelectDropDownValueProps,
DropDownListValueProps
>;

// MANUAL OVERRIDE
const CellSelectDropDown: React.FC<CellSelectDropDownValueProps> = ({
  id,
  className,
  toggleProps,
  menuProps,
  offset,
}) => (
  <DropdownWrapper
    id={id}
    Toggle={InternalCellSelectDropDown}
    Menu={DropDownList}
    toggleProps={toggleProps}
    menuProps={menuProps}
    className={cx(styles.dropDownList, className)}
    alignEnd={true}
    offset={offset?.length ? offset : [CELL_DROPDOWN_X_OFFSET, CELL_DROPDOWN_Y_OFFSET]}
  />
);

export default CellSelectDropDown;
